import { render, staticRenderFns } from "./Janet.vue?vue&type=template&id=6ea67ee1&scoped=true&"
import script from "./Janet.vue?vue&type=script&lang=js&"
export * from "./Janet.vue?vue&type=script&lang=js&"
import style0 from "./Janet.vue?vue&type=style&index=0&id=6ea67ee1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea67ee1",
  null
  
)

export default component.exports